import React, { useState } from "react"
import { Button, Icon, GridColumn, Grid, Divider, Accordion } from "semantic-ui-react"

import GeneralInputs from "./config/GeneralInputs"
import Customer from "./config/Customer"
import CTP from "./config/CTP"
import DCF from "./config/DCF"
import { clearLocalStorage } from "../store/SrciStore"
import ApplePay from "./config/ApplePay"
import GooglePay from "./config/GooglePay"

export default function ConfigPage() {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <React.Fragment>
      <GridColumn width={16}>
        <Button icon labelPosition="left" onClick={() => clearLocalStorage()}>
          <Icon name="redo" />
          Reset to default's
        </Button>

        <Divider hidden />

        <Grid>
          <Grid.Row>
            <GridColumn computer={16} tablet={16}>
              <Accordion styled fluid>
                <Accordion.Title index={0} active={activeIndex === 0} onClick={() => setActiveIndex(0)}>
                  <Icon name="payment" />
                  DCF's
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                  <DCF />
                </Accordion.Content>

                <Accordion.Title index={1} active={activeIndex === 1} onClick={() => setActiveIndex(1)}>
                  <Icon name="wordpress forms" />
                  General Inputs
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 1}>
                  <GeneralInputs />
                </Accordion.Content>

                <Accordion.Title index={2} active={activeIndex === 2} onClick={() => setActiveIndex(2)}>
                  <Icon name="user" />
                  Customer
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 2}>
                  <Customer />
                </Accordion.Content>

                <Accordion.Title index={3} active={activeIndex === 3} onClick={() => setActiveIndex(3)}>
                  <Icon name="apple pay" />
                  ApplePay
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 3}>
                  <ApplePay />
                </Accordion.Content>

                <Accordion.Title index={4} active={activeIndex === 4} onClick={() => setActiveIndex(4)}>
                  <Icon name="google wallet" />
                  Google Pay
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 4}>
                  <GooglePay />
                </Accordion.Content>

                <Accordion.Title index={6} active={activeIndex === 6} onClick={() => setActiveIndex(6)}>
                  <Icon name="wordpress forms" />
                  CTP
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 6}>
                  <CTP />
                </Accordion.Content>
              </Accordion>
            </GridColumn>
          </Grid.Row>
        </Grid>
      </GridColumn>
    </React.Fragment>
  )
}
